import { cva } from 'class-variance-authority';


/**
 * Shared control-frame classes for the DESIGN.md `input`/`select`/`autocomplete`
 * token: surface-1 fill, hairline-strong border, md radius, and a 1px primary
 * border + soft focus glow. Composed via `cn()` by Input, Textarea, Select and
 * Autocomplete so a control-styling change lives in one place (DRY).
 *
 * Sizing (height/padding/text) stays at the call site — it varies per control.
 * `focus` picks the focus family: `visible` for controls that own their border
 * (input/textarea/select), `within` for wrappers whose inner input is borderless
 * (the adorned Input shell, Autocomplete). Every class is a full literal so
 * Tailwind's static scanner emits them.
 */
const fieldFrame = cva('rounded-md bg-surface-1 border border-hairline-strong', {
  variants: {
    focus: {
      visible: 'focus-visible:border-primary focus-visible:ring-focus',
      within: 'focus-within:border-primary focus-within:ring-focus',
    },
    invalid: {
      'true': '',
      'false': '',
    },
  },
  compoundVariants: [
    { focus: 'visible', invalid: true, className: 'border-danger focus-visible:border-danger' },
    { focus: 'within', invalid: true, className: 'border-danger focus-within:border-danger' },
  ],
  defaultVariants: {
    focus: 'visible',
    invalid: false,
  },
});


export { fieldFrame };
export default fieldFrame;
